export interface PasswordValidationResult {
    isValid: boolean;
    strength: number; // 0 - 100
    checks: {
        length: boolean;
        upper: boolean;
        lower: boolean;
        digit: boolean;
        special: boolean;
        allowedChars: boolean;
    };
    errors: string[];
}

/**
 * Generic password validator used across the app.
 *
 * Rules:
 * - Minimum length 10
 * - Allowed characters: A-Z, a-z, 0-9, and ! @ # $ % ^ & * _ - + = ?
 * - Strength is based on length and character variety.
 */
export const validatePassword = (password: string): PasswordValidationResult => {
    const errors: string[] = [];

    const length = password.length >= 10;
    const upper = /[A-Z]/.test(password);
    const lower = /[a-z]/.test(password);
    const digit = /[0-9]/.test(password);
    const special = /[!@#$%^&*_\-+=?]/.test(password);
    const allowedChars = /^[A-Za-z0-9!@#$%^&*_\-+=?]*$/.test(password);

    if (!length) {
        errors.push("Password must be at least 10 characters long.");
    }

    if (!allowedChars) {
        errors.push(
            "Password contains invalid characters. Only letters, numbers and ! @ # $ % ^ & * _ - + = ? are allowed."
        );
    }

    // Strength: each satisfied condition contributes 20%
    const checksPassed = [length, upper, lower, digit, special].filter(Boolean).length;
    const strength = (checksPassed / 5) * 100;

    const isValid = length && allowedChars;

    return {
        isValid,
        strength,
        checks: { length, upper, lower, digit, special, allowedChars },
        errors,
    };
};


